import React from "react";
import Image from "next/image";
import bannerImage from "assets/images/20-percent.png";
import { ParagraphText, Span, TextHeadingOne } from "styles/typography";
import { BannerWrapper } from "./affiliate-program.styles";

const AffiliateProgramBanner = () => {
   return (
      <BannerWrapper>
         <div>
            <TextHeadingOne>
               <Span color="#7211d4">Earn</Span> 20% commission when you refer us".
            </TextHeadingOne>
            <ParagraphText>
               We take care of everything, including hosting the products and providing customer
               service.
            </ParagraphText>
         </div>

         <div>
            <Image src={bannerImage} alt="Earn 20% Commission" />
         </div>
      </BannerWrapper>
   );
};

export { AffiliateProgramBanner };
